import React, {lazy} from 'react'

import {RouteObject} from 'react-router'

import ProtectRouter from '../components/protect.router'
import Redirect from '../components/redirect'
import PersonRouter from './person'
import CompanyRouter from './company'
import DocumentsRouter from './document'
import InstitutionsRouter from './institutions'
import {UserType} from '../application/domain/utils/user.type'
import {LogicalStrategy} from "../services/auth";

const Layout = lazy(() => import('../containers/layout'))
const Home = lazy(() => import('../containers/home/home'))
const Vehicles = lazy(() => import('../containers/vehicle/vehicles'))
const Users = lazy(() => import('../containers/users'))
const Profile = lazy(() => import('../containers/profile'))
const Address = lazy(() => import('../containers/address/address'))
const Contacts = lazy(() => import('../containers/contacts/contacts'))
const Relationships = lazy(() => import('../containers/relationships/relationships'))


const LayoutRouter: RouteObject[] = [
    {
        path: '/',
        element: <Redirect to="/app/home"/>
    },
    {
        path: '/app',
        element: <ProtectRouter privateRouter={true}>
            <Layout/>
        </ProtectRouter>,
        children: [
            {
                path: '/app',
                element: <Redirect to="/app/home"/>
            },
            {
                path: '/app/home',
                element: <Home/>
            },
            {
                path: '/app/vehicles',
                element: <ProtectRouter privateRouter={true} scopes={[ 've:ra' ]}>
                    <Vehicles/>
                </ProtectRouter>
            },
            {
              path: '/app/address',
              element: <ProtectRouter privateRouter={true} scopes={['pe:ra', 'cp:ra']} logicalStrategy={LogicalStrategy.OR}>
                  <Address/>
              </ProtectRouter>
            },
            {
                path: '/app/users',
                element: <ProtectRouter privateRouter={true} types={[ UserType.ADMIN ]}>
                    <Users/>
                </ProtectRouter>
            },
            {
                path: '/app/myprofile',
                element: <Profile/>
            },
            {
                path: '/app/contacts',
                element: <ProtectRouter privateRouter={true} scopes={['pe:ra', 'cp:ra']} logicalStrategy={LogicalStrategy.OR}>
                    <Contacts/>
                </ProtectRouter>
            },
            {
                path: '/app/relationships',
                element: <ProtectRouter privateRouter={true} scopes={['re:ra']}>
                    <Relationships/>
                </ProtectRouter>
            },
            ...PersonRouter,
            ...CompanyRouter,
            ...DocumentsRouter,
            ...InstitutionsRouter
        ]
    }
]

export default LayoutRouter
